/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateAddressResponseDto
 */
export interface CreateAddressResponseDto {
    /**
     * Address unique identifier
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'id': string;
    /**
     * User ID who owns this address
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'userId': string;
    /**
     * Address name/label
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'name': string;
    /**
     * Contact number for this address
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'contactNumber': string;
    /**
     * Address type
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'type': CreateAddressResponseDtoTypeEnum;
    /**
     * Country name
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'country': string;
    /**
     * Country code
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'countryCode': string;
    /**
     * Province name
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'province': string;
    /**
     * Province code
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'provinceCode': string;
    /**
     * City name
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'city'?: string;
    /**
     * City code
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'cityCode'?: string;
    /**
     * Barangay name
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'barangay'?: string;
    /**
     * Barangay code
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'barangayCode'?: string;
    /**
     * Street address
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'street'?: string;
    /**
     * Additional address line (apartment, unit, floor, building)
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'addressLine2'?: string;
    /**
     * Postal code
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'postalCode'?: string;
    /**
     * Source API for address data
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'sourceApi'?: CreateAddressResponseDtoSourceApiEnum;
    /**
     * Full formatted address
     * @type {string}
     * @memberof CreateAddressResponseDto
     */
    'fullAddress'?: string;
}

export const CreateAddressResponseDtoTypeEnum = {
    Home: 'home',
    Work: 'work',
    Shipping: 'shipping'
} as const;

export type CreateAddressResponseDtoTypeEnum = typeof CreateAddressResponseDtoTypeEnum[keyof typeof CreateAddressResponseDtoTypeEnum];
export const CreateAddressResponseDtoSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type CreateAddressResponseDtoSourceApiEnum = typeof CreateAddressResponseDtoSourceApiEnum[keyof typeof CreateAddressResponseDtoSourceApiEnum];


